import type { IAuthUser, IUser } from '@shared/user';
import { USER_ICON_KEY, USER_KEY } from '~/utils/defs';

export const useUserStore = defineStore('user', () => {
    const localUser = ref<IUser | IAuthUser | null>(null);
    const { setItem, getItem, removeItem } = useLocalStorage();
    const userIcon = ref<string>('');

    const setUser = (user: IUser | IAuthUser) => {
        setItem(USER_KEY, user);
        localUser.value = user;
    }

    const removeUser = () => {
        removeItem(USER_KEY);
        localUser.value = null;
    }

    const initUser = () => {
        const temp = getItem(USER_KEY);
        if(temp) localUser.value = temp;
    }

    const getUser = () => {
        initUser();
        return localUser.value;
    }

    const initUserIcon = () => {
        const temp = getItem(USER_ICON_KEY);
        if(temp) userIcon.value = temp;
    }

    const getCustomerId = () => {
        return getItem(CUSTOMER_ID_KEY, '');
    }

    return {
        setUser,
        removeUser,
        user: localUser,
        initUser,
        getUser,
        initUserIcon,
        userIcon,
        getCustomerId,
    }
})